<template>
  <div class="member-page member-layout" :style="layoutHeight">
    <aside class="member-sidebar pt-6">
      <Menu :selectedKeys="selectedKeys" />
    </aside>
    <main class="member-main">
      <route-view :key="$store.state.user.sessionVersion" />
    </main>
  </div>
</template>
<script>
import Menu from '@/views/admin/menu/index.vue';
import RouteView from './RouteView.vue';
export default {
  name: 'MemberLayout',
  components: { Menu, RouteView },
  computed: {
    selectedKeys() {
      return [{ AdminInfo: 2, PContract: 5, Reserve: 8, TeamPerformance: 9 }[this.$route.name]];
    },
    layoutHeight() {
      return { minHeight: this.$store.getters.getConfig.is_header
        ? 'calc(100vh - 135px)' : 'calc(100vh - 115px)' };
    },
  },
};
</script>
<style lang="less">
.member-layout {
  display: flex;
  align-items: stretch;
  > .member-sidebar { flex: 0 0 128px; width: 128px; }
  > .member-main { flex: 1; min-width: 0; }
}
</style>
